/* eslint-disable */
import { homeRoute } from './home';
import { contentRoute } from './content';
import { newsRoute } from './news';
import { productRoute } from './product';
import { recruitMagRoute } from './recruitMag';
import { BrowsingHistory } from './BrowsingHistory';
import { BusinessesRoute } from './Businesses';
import { baseSettingRoute } from './BaseSetting';
import { TemplateRoute } from './Template';
import { FileResourcesRoute } from './FileResources';
import {flattenTree, getStorage, searchTree} from "@/libs/utils";
// 默认路由
const defaultRoutes = [
  { path: '*', component: () => import('@/views/404/index.vue') },
  { path: '/', redirect: 'login' },
  { path: '/login', name: 'login', component: () => import('@/views/login/login.vue') },
];

// 权限判断
export const getConstantRouterMap = () => {
  let routes = [];
  let routeRole = JSON.parse(getStorage("routeRole"));
  if (!(routeRole && routeRole.length)) return routes;
  // let routeRole = JSON.parse(getStorage("routeRole"));
  const allArray = flattenTree({
    id: null,
    child: routeRole
  }, 'child');
  const routeNames = allArray.filter(it => it.webUrl).map(a => a.webUrl);
  const menuNames = allArray.filter(it => it.webUrl).map(a => a.menuName);
  let menuNameData = {};
  routeNames.forEach((it, index) => {
    menuNameData[it] = menuNames[index];
  })
  routes = searchTree({children: pageRoutes.splice(1, pageRoutes.length)},
    node => routeNames.includes(node.name)
      || (node.path && !node.name && routeNames.includes(node.children[0].name)), menuNameData)
  return routes.children;
};

// 菜单路由
export const pageRoutes = [
  ...homeRoute,
  ...contentRoute,
  ...newsRoute,
  ...productRoute,
  ...BusinessesRoute,
  ...recruitMagRoute,
  ...BrowsingHistory,
  ...baseSettingRoute,
  ...FileResourcesRoute,
  ...TemplateRoute,
];

export default [...defaultRoutes, ...homeRoute, ...getConstantRouterMap()];
